'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDesignSystemButtonIconCss = exports.getDesignSystemButtonSizeCss = exports.getDesignSystemButtonColorCss = exports.getDesignSystemButtonBaseCss = exports.getDesignSystemButtonWidth = exports.getDesignSystemButtonBoxShadow = exports.getDesignSystemButtonSizes = exports.getDesignSystemButtonPadding = exports.getDesignSystemButtonColors = undefined;

var _lodash = require('lodash');

var _styledComponents = require('styled-components');

var _buttonStyles = require('../config/data/button-styles');

var _button = require('../config/data/button');

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var colors = _buttonStyles.buttonStyles.colors,
    spacings = _buttonStyles.buttonStyles.spacings,
    sizes = _buttonStyles.buttonStyles.sizes,
    boxShadows = _buttonStyles.buttonStyles.boxShadows,
    fontWeight = _buttonStyles.buttonStyles.fontWeight;
var getDesignSystemButtonColors = exports.getDesignSystemButtonColors = function getDesignSystemButtonColors(token, color) {
    if (token.includes(_button.EXPAND) || token.includes(_button.DIRECT)) {
        return colors.buttonExpand;
    }
    if (token.includes(_button.SECONDARY)) {
        return token.includes(_button.FULL) ? colors.buttonSecondaryFull : colors.buttonSecondaryLight;
    }
    var colorKey = (0, _lodash.camelCase)(_button.BUTTON + "-" + color);
    return colors[colorKey] || colors.buttonAction1;
};
var getDesignSystemButtonPadding = exports.getDesignSystemButtonPadding = function getDesignSystemButtonPadding(token) {
    var haveIcon = token.includes(_button.WITH_ICON);
    if (token.includes(_button.BIG) && !haveIcon) {
        return spacings.padding.large;
    }
    return token.includes(_button.SMALL) && haveIcon ? spacings.padding.small : spacings.padding.medium;
};
var getDesignSystemButtonSizes = exports.getDesignSystemButtonSizes = function getDesignSystemButtonSizes(token) {
    if (token.includes(_button.EXPAND) || token.includes(_button.DIRECT)) {
        return sizes.buttonExpand;
    }
    if (token.includes(_button.SECONDARY)) {
        return sizes.buttonSecondary;
    }
    if (token.includes(_button.BIG)) {
        return sizes.buttonBig;
    }
    return sizes.buttonSmall;
};
var getDesignSystemButtonBoxShadow = exports.getDesignSystemButtonBoxShadow = function getDesignSystemButtonBoxShadow(token) {
    if (token.includes(_button.EXPAND) || token.includes(_button.DIRECT)) {
        return boxShadows.light;
    }
    if (token.includes(_button.BIG) && token.includes(_button.WITH_SHADOW)) {
        return boxShadows.dark;
    }
    return boxShadows.none;
};
var getDesignSystemButtonWidth = exports.getDesignSystemButtonWidth = function getDesignSystemButtonWidth(token) {
    return token.split(_button.SPLIT_SEPARATOR).includes(_button.FULL_WIDTH) ? spacings.width.fullWidth : spacings.width.default;
};
var getDesignSystemButtonBaseCss = exports.getDesignSystemButtonBaseCss = function getDesignSystemButtonBaseCss(_a) {
    var type = _a.type;
    var buttonBoxShadow = getDesignSystemButtonBoxShadow(type);
    return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    && {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: ", ";\n      box-shadow: ", ";\n\n      & > span,\n      div {\n        text-align: center;\n        width: 100%;\n      }\n\n      &::after {\n        border: 0 none;\n        opacity: 0;\n        animation: none 0 ease 0 1 normal;\n      }\n    }\n  "], ["\n    && {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: ", ";\n      box-shadow: ", ";\n\n      & > span,\n      div {\n        text-align: center;\n        width: 100%;\n      }\n\n      &::after {\n        border: 0 none;\n        opacity: 0;\n        animation: none 0 ease 0 1 normal;\n      }\n    }\n  "])), fontWeight, buttonBoxShadow);
};
var getDesignSystemButtonColorCss = exports.getDesignSystemButtonColorCss = function getDesignSystemButtonColorCss(_a) {
    var type = _a.type,
        color = _a.color,
        outline = _a.outline;
    var buttonColors = getDesignSystemButtonColors(type, color);
    var fontColor = outline ? buttonColors.background : buttonColors.font;
    var backgroundColor = outline ? buttonColors.font : buttonColors.background;
    var hoverColor = outline ? buttonColors.font : buttonColors.hover;
    var borderColor = outline ? buttonColors.background : buttonColors.borderColor;
    return (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n      transition: all 0.7s ease;\n      ", " &:hover,\n      &:active,\n      &:focus {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n        ", ";\n      }\n    }\n  "], ["\n    && {\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n      transition: all 0.7s ease;\n      ", " &:hover,\n      &:active,\n      &:focus {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n        ", ";\n      }\n    }\n  "])), fontColor, backgroundColor, borderColor || 'transparent', buttonColors.boxShadow && "box-shadow: " + buttonColors.boxShadow + ";", fontColor, hoverColor || backgroundColor, borderColor || 'transparent', buttonColors.hoverBoxShadow && "box-shadow: " + buttonColors.hoverBoxShadow + ";");
};
var getDesignSystemButtonSizeCss = exports.getDesignSystemButtonSizeCss = function getDesignSystemButtonSizeCss(_a) {
    var type = _a.type;
    var buttonSizes = getDesignSystemButtonSizes(type);
    var buttonWidth = getDesignSystemButtonWidth(type);
    var buttonPadding = getDesignSystemButtonPadding(type);
    return (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    && {\n      line-height: ", ";\n      height: ", ";\n      border-radius: ", ";\n      font-size: ", ";\n      width: ", ";\n      padding: ", ";\n    }\n  "], ["\n    && {\n      line-height: ", ";\n      height: ", ";\n      border-radius: ", ";\n      font-size: ", ";\n      width: ", ";\n      padding: ", ";\n    }\n  "])), buttonSizes.lineHeight, buttonSizes.height, buttonSizes.borderRadius, buttonSizes.fontSize, buttonWidth, buttonPadding);
};
var getDesignSystemButtonIconCss = exports.getDesignSystemButtonIconCss = function getDesignSystemButtonIconCss(_a) {
    var type = _a.type,
        active = _a.active;
    var buttonSizes = getDesignSystemButtonSizes(type);
    return (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    && {\n      & > svg {\n        width: ", ";\n        height: ", ";\n        transform: ", ";\n        transition: all 0.5s ease;\n      }\n\n      span + svg {\n        margin-left: 8px;\n      }\n\n      .anticon > svg {\n        width: ", ";\n        height: ", ";\n        transform: ", ";\n        transition: all 0.5s ease;\n      }\n\n      & > img {\n        width: ", ";\n        height: ", ";\n      }\n\n      & > img + span,\n      span + img,\n      svg + span {\n        margin-left: 8px;\n      }\n    }\n  "], ["\n    && {\n      & > svg {\n        width: ", ";\n        height: ", ";\n        transform: ", ";\n        transition: all 0.5s ease;\n      }\n\n      span + svg {\n        margin-left: 8px;\n      }\n\n      .anticon > svg {\n        width: ", ";\n        height: ", ";\n        transform: ", ";\n        transition: all 0.5s ease;\n      }\n\n      & > img {\n        width: ", ";\n        height: ", ";\n      }\n\n      & > img + span,\n      span + img,\n      svg + span {\n        margin-left: 8px;\n      }\n    }\n  "])), buttonSizes.iconSize, buttonSizes.iconSize, active && type.includes(_button.EXPAND) ? 'rotate(180deg)' : 'none', buttonSizes.iconSize, buttonSizes.iconSize, active && type.includes(_button.EXPAND) ? 'rotate(180deg)' : 'none', buttonSizes.iconSize, buttonSizes.iconSize);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=design-system-button-styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/helpers/design-system-button-styles.js
// module id = 1908
// module chunks = 0